import { faBan } from '@fortawesome/free-solid-svg-icons';
import styles from './SizeIcon.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { playColors } from '../../constants';

export const SizeIcon = ({
  size,
  color = playColors.highlight,
}: {
  size: 'off' | 'small' | 'medium' | 'large';
  color?: string;
}) => {
  const Size: React.FC = ({ children }) => (
    <div className={styles.size} style={{ color, borderColor: color }}>
      {children}
    </div>
  );
  switch (size) {
    case 'small':
      return <Size>S</Size>;

    case 'medium':
      return <Size>M</Size>;

    case 'large':
      return <Size>L</Size>;

    default:
      return (
        <FontAwesomeIcon
          icon={faBan}
          style={{
            fontSize: 18,
            color,
            fontWeight: 300,
          }}
        />
      );
  }
};
